<template>
    <section class="telegram-invitation-report mb-3">
        <h6>{{ group.name }}</h6>
        <p v-if="canResolve" class="small text-muted">«Отметить решённым» сохраняет только вашу отметку. Для автоматической проверки и добавления участников используйте «Продолжить настройку» в карточке группы.</p>
        <ul v-if="open.length" class="list-unstyled mb-2">
            <li v-for="incident in open" :key="incident.key" class="mb-3">
                <strong>{{ incident.name }}</strong><span v-if="incident.is_admin" class="text-muted small"> · выбран администратором</span>
                <div class="small">{{ issueText(incident) }}</div>
                <b-button v-if="canResolve && incident.fingerprint" variant="link" size="sm" class="px-0 py-1" :disabled="busy" @click="$emit('resolve', {kind: group.kind, incident, resolved: true})">Отметить решённым</b-button>
            </li>
        </ul>
        <p v-else class="small mb-2">Открытых инцидентов нет. Решение отмечено вручную.</p>
        <details v-if="resolved.length" class="small">
            <summary>Решённые вручную: {{ resolved.length }}</summary>
            <ul class="list-unstyled mt-2 mb-0">
                <li v-for="incident in resolved" :key="incident.key" class="mb-2">
                    <strong>{{ incident.name }}</strong> — {{ issueText(incident) }}
                    <div class="text-muted">Отметил: {{ incident.resolution.resolved_by_name }} · {{ date(incident.resolution.resolved_at) }}</div>
                    <b-button v-if="canResolve" variant="link" size="sm" class="px-0 py-1" :disabled="busy" @click="$emit('resolve', {kind: group.kind, incident, resolved: false})">Вернуть в открытые</b-button>
                </li>
            </ul>
        </details>
    </section>
</template>
<script>
import {telegramIncidents, invitationIssueText} from '@/utils/objectTelegramGroups';
export default {
    props: {group: {type: Object, required: true}, users: {type: Array, default: () => []}, canResolve: Boolean, busy: Boolean},
    computed: {
        incidents() { return telegramIncidents(this.group, this.users); },
        open() { return this.incidents.filter(incident => !incident.resolution); },
        resolved() { return this.incidents.filter(incident => incident.resolution); }
    },
    methods: {
        issueText(incident) {
            if (incident.type === 'user') return invitationIssueText(incident);
            if (incident.type === 'bot') return 'Добавление служебного бота не подтверждено. Передайте его имя администратору Аргуса.';
            if (incident.type === 'admins') return 'Проверьте назначение выбранных администраторов в Telegram.';
            if (incident.type === 'settings') return 'Не удалось полностью настроить группу. Проверьте её настройки в Telegram.';
            return incident.message || 'Проверьте состав и права участников в Telegram.';
        },
        date(value) { return new Date(value).toLocaleString('ru-RU'); }
    }
};
</script>
<style scoped>
.telegram-invitation-report {padding-bottom: 8px; border-bottom: 1px solid #e1e6eb; overflow-wrap: anywhere;}
.telegram-invitation-report h6 {font-weight: 600;}
</style>
